module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offer"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.plans.slice(_vm.rangeStart, _vm.rangeEnd)), function(plan) {
    return _c('div', {
      staticClass: "tile is-parent is-size-4"
    }, [_c('article', {
      staticClass: "tile is-child notification is-black",
      class: {
        'is-highlighted': plan.highlight
      }
    }, [_c('div', {
      staticClass: "content"
    }, [(plan.url) ? _c('p', {
      staticClass: "title is-size-3"
    }, [_c('router-link', {
      attrs: {
        "to": plan.url
      }
    }, [_vm._v("\n            " + _vm._s(plan.name))])], 1) : _c('p', {
      staticClass: "title is-size-3"
    }, [_vm._v(_vm._s(plan.name))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', [_vm._v(_vm._s(plan.time))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(plan.description[0]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(plan.description[1]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(plan.description[2]))])])]), _vm._v(" "), _c('div', {}, [_c('a', {
      staticClass: "button is-black is-block is-large",
      attrs: {
        "href": plan.cta
      }
    }, [_vm._v(_vm._s(plan.price) + "€ / " + _vm._s(plan.period))])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1031faa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Offer.vue
// module id = 160
// module chunks = 0 5 6 7 8